import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BookingProvider } from "./context/BookingContext";
import { AdminProvider } from "./context/AdminContext";
import { LanguageProvider } from "./context/LanguageContext";
import { BusinessProvider } from "./context/BusinessContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";
import Home from "./pages/Home";
import { CabinsList, CabinDetail } from "./pages/Cabins";
import Booking from "./pages/Booking";
import Mazamitla from "./pages/Mazamitla";
import Contact from "./pages/Contact";
import AdminPage from "./pages/Admin";

// Layout wrapper for public pages
const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <main className="min-h-screen">{children}</main>
    <Footer />
    <WhatsAppButton />
  </>
);

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BusinessProvider>
          <AdminProvider>
            <BookingProvider>
              <BrowserRouter>
                <Routes>
                  {/* Admin route - no navbar/footer */}
                  <Route path="/admin" element={<AdminPage />} />
                  
                  {/* Public routes with layout */}
                  <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
                  <Route path="/cabanas" element={<PublicLayout><CabinsList /></PublicLayout>} />
                  <Route path="/cabanas/:id" element={<PublicLayout><CabinDetail /></PublicLayout>} />
                  <Route path="/reservar" element={<PublicLayout><Booking /></PublicLayout>} />
                  <Route path="/mazamitla" element={<PublicLayout><Mazamitla /></PublicLayout>} />
                  <Route path="/contacto" element={<PublicLayout><Contact /></PublicLayout>} />
                </Routes>
              </BrowserRouter>
            </BookingProvider>
          </AdminProvider>
        </BusinessProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
